/* eslint-disable no-unused-vars */

(() => {
  const featuredDefault = new Swiper(".js-default-collections-swiper", {
    centerInsufficientSlides: true,
    slidesPerView: "auto",
    spaceBetween: 16,
    breakpoints: {
      1200: {
        enabled: false,
        centerInsufficientSlides: false,
        spaceBetween: 0,
      },
    },
  });

  const featuredVendor = new Swiper(".js-vendor-collections-swiper", {
    centerInsufficientSlides: true,
    slidesPerView: "auto",
    spaceBetween: 24,
  });
})();
